import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Tooltip,
  Button,
  Upload,

} from "antd";
import { LoadingOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import './UploadTenantModal.scss'
import commonFn from "@/utils/commonFn";

const UploadTenantModal = forwardRef(({submitInitFn}, ref) => {
    const [modalName, setModalName] = useState('');
    const [modalFlag, setModalFlag] = useState(false);
    const [downloadLoadingFlag, setDownloadLoadingFlag] = useState(-1);
    const [downloadList, setDownloadList] = useState([]);
    const [uploadFileState, setUploadFileState] = useState({});

    const [fileList, setFileList] = useState([]);
      
    const [uploadLoading, setUploadLoading] = useState(null);
    const [uploadFileList, setUploadFileList] = useState([]);
    
    useImperativeHandle(ref, () => ({
      openModal: ({modalName = 'Upload', downloadList = [], uploadFileState} = {}) => {
        setModalName(modalName)
        if(downloadList?.length){
          setDownloadList(downloadList)
        }
        if(uploadFileState){
          setUploadFileState(uploadFileState)
        }
        setModalFlag(true)
      }
    }));

    const afterOpenChangeFn = (flag) => {
      if(flag){
        setFileList([])
        setUploadLoading(null)
      }else{
      }
    }
    // const testFn = async () => {
    // }

    const downloadFn = async({url, params, type, suffix, name} = {}, index) => {
      setDownloadLoadingFlag(index)
      // const blob = await http.get(url, {
      //   params,
      //   responseType: "blob",
      // });
      // await commonFn.getBlobExcelFn({
      //   blob,
      //   type,
      //   suffix,
      //   name,
      // })
      const typeMatch = {
        1: {
          href: '/files/Mortgage.docx',
          name: 'Mortgage-Upload-Instruction.docx',
        },
        2: {
          href: '/files/Mortgage.csv',
          name: 'Mortgage-Upload-Sample.csv',
        },
        3: {
          href: '/files/EnterPayment.docx',
          name: 'Mortgage-Upload-Prop-Instruction.docx',
        },
        4: {
          href: '/files/EnterPayment.csv',
          name: 'Mortgage-Upload-Prop-Sample.csv',
        },
        5: {
          href: '/files/MortgageAndEnterPayment.docx',
          name: 'Mortgage-Upload-All-Instruction.docx',
        },
        6: {
          href: '/files/MortgageAndEnterPayment.csv',
          name: 'Mortgage-Upload-All-Sample.csv',
        }
      }
      const link = document.createElement("a");
      link.href = typeMatch[params.type].href;
      link.download = typeMatch[params.type].name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setDownloadLoadingFlag(-1)
    }

    const formatSizeFn = (bytes) => {
      const units = ['KB', 'MB', 'GB']
      let size = bytes / 1024
      let index = 0

      while (size >= 1024 && index < units.length - 1) {
        size /= 1024
        index++
      }

      return `${size.toFixed(2)} ${units[index]}`
    }

    const handleFileListFn = (data, flag) => {
      const { file, id } = data
      setFileList(arr => {
        let list = []
        if(id){
          list = arr.map(item => ({ ...item, isSuccess: item.id === id ? flag : item.isSuccess}))
        } else {
          list = [
            ...arr,
            {...data, isSuccess: flag, id: +new Date(), name: file.name, size: formatSizeFn(file.size)}
          ]
        }
        return list
      })
    }

    const uploadFileFn = async(data) => {
      const { file } = data
      if(fileList.some(item => item.name === file.name) && !data?.id){
        commonFn.modalFailedFn({
          code: "0",
          msg: "The current file name already exists, please do not resubmit!",
        });
        return
      }
      if(uploadLoading) return
      setUploadLoading(data?.id || 99999999)
      const formData = new FormData();
      formData.append("file", file)
      if(uploadFileState?.params){
        Object.keys(uploadFileState.params)?.map(item => {
          formData.append([item], uploadFileState.params[item])
        })
      }
      const response = await http.post(uploadFileState.url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }); 
      if (response.code === "1") {
        handleFileListFn(data, true)
        submitInitFn()
      } else {
        handleFileListFn(data, false)
        commonFn.modalFailedFn(response);
      }
      setUploadFileList([])
      setUploadLoading(null)
    }

  return (
    <Modal
      title={
        <div style={{ fontSize: "18px", fontFamily: 'Inter', fontWeight: "bold", color: "#0E172B" }}>
          {modalName}
          <div style={{ borderTop: "1px solid #E2E8F0", margin: "20px -24px 0 -24px" }}></div>
        </div>
      }
      className="UploadTenantModal"
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      afterOpenChange={afterOpenChangeFn}
      width="40%"
    >
      <div className="box">
        <div className="uploadFile">
          {commonFn.iconDocFn({iconKey: 'fileIcon', width: 24, height: 24})}
          <div className="uploadFileDesc">Informaton</div>
          <div className="uploadFileBtn">
            <Upload 
              listType="text"
              fileList={uploadFileList}
              onChange={uploadFileFn}
              accept=".csv"
              multiple
              beforeUpload={() => false}
            >
              {commonFn.btnDocFn({ name: 'Upload File', btnFn: () => {}, loading: uploadLoading === 99999999, disabled: uploadLoading && uploadLoading !== 99999999 },{
                iconKey: 'uploadIcon',
                imageStyle: { filter: "brightness(0) invert(1)" }
              })}
            </Upload>
          </div>
        </div>
        <div className="download">
          {downloadList?.map(({iconKey, text, desc, downloadState}, index) => (
            <div className="downloadItem">
              <div className="downloadtitle">
                { downloadLoadingFlag === index ? <LoadingOutlined /> : commonFn.iconDocFn({iconKey})}
                <a className="downloadText" onClick={() => downloadFn(downloadState, index)}>{text}</a>
              </div>
              <div className="downloadDesc">{desc}</div>
            </div>
          ))}
        </div>
        <div className="fileList">
          {fileList?.map((item) => (
            <div className="fileListItem">
              <div className="baseInfo">
                  <div className="name">
                    <Tooltip placement="topLeft" title={item.name}>
                      {item.name}
                    </Tooltip>
                  </div>
                <div className="statusInfo">
                  <div className="size">{item.size}</div>
                  <div className="circle"></div>
                  {commonFn.iconDocFn({iconKey: item.isSuccess ? 'successIcon' : 'failIcon'})}
                  <div className={[item.isSuccess ? 'success' : 'fail']}>{`Upload ${ item.isSuccess ? 'Succesed' : 'Failed'}`}</div>
                </div>
              </div>
              {!item.isSuccess && <div className="failBtn">
                <Button className="Cancel" onClick={() => setFileList(fileList.filter(v => v.id !== item.id))} disabled={uploadLoading}>Cancel</Button>
                <Button className="Retry" onClick={() => uploadFileFn(item)} loading={uploadLoading === item.id} disabled={uploadLoading && uploadLoading !== item.id}>Retry</Button>
              </div> || null}
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
});

export default UploadTenantModal;